<template>
	<v-row no-gutters v-if="localCnameData" align="center" class="list_item">
		<v-col cols="auto">
			<v-card class="ac_card integration inline-block">
				<div class="centerdXY">
					<SIcon :width="18" :name="service.service_slug" v-if="service.service_slug" />
				</div>
			</v-card>
		</v-col>
		<v-col class="pl-3">
			<h3 class="d_name light">
				<span>{{ service.service_name }}</span>
			</h3>
			<p>{{ localCnameData.cname }}</p>
		</v-col>

		<v-col class="text-right">
			<v-menu absolute right bottom :close-on-content-click="false">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon fab x-small rounded class="menu_btn" v-bind="attrs" v-on="on">
						<SIcon name="dots-h" class="si" iconColor="#959DA1" style="top: -3px; left: -1px" :width="14"></SIcon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item>
						<v-list-item-title><v-btn text @click="deleteCname" :loading="loadingRemove">Delete</v-btn></v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-col>
		<v-col cols="12" class="mt-3 mb-1">
			<v-divider style="border-color: #eff1f7 !important"></v-divider>
		</v-col>
	</v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	name: 'SettingsCnamesListItem',
	components: {},
	computed: {
		...mapGetters(['apps/getService']),
		service() {
			return this['apps/getService'](this.localCnameData.serviceId) || {};
		},
	},
	methods: {
		...mapActions(['account/removeCname']),
		copyCnameData() {
			this.$set(this, 'localCnameData', this.cnameData);
		},
		async deleteCname() {
			this.loadingRemove = true;
			await this['account/removeCname']({ ...this.localCnameData });
			this.loadingRemove = false;
		},
	},
	props: {
		cnameData: {
			type: Object,
		},
	},
	watch: {
		cnameData: {
			handler(newV) {
				if (newV) {
					this.copyCnameData();
				}
			},
			deep: true,
			immediate: true,
		},
	},
	data: () => ({
		localCnameData: null,
		loadingRemove: false,
	}),
};
</script>

<style scoped>
.ac_card {
	width: 43px;
	height: 43px !important;
	border-color: #e1e1e1 !important;
}
p {
	font-size: 12px;
	color: #919191;
	line-height: 15px;
}
.menu_btn {
	border: 1px solid #959da1 !important;
	width: 25px;
	height: 25px;
	background-color: var(--page-background);
	transition: all 0.2s;
	opacity: 0;
	position: absolute;
	margin-left: 3px;
}
.edit_name {
	width: 21px;
	height: 21px;
	opacity: 0;
	background: #f0f1f3 !important;
	transition: 0.2s;
	position: absolute;
	right: 0px;
	top: 0px;
}
.list_item:hover .menu_btn {
	opacity: 1;
}
.list_item:hover .edit_name {
	opacity: 1;
}
.u_icon {
	transform: scale(0.8);
	display: inline-block;
	vertical-align: middle;
}
.test_btn {
	text-transform: capitalize !important;
	font-weight: 400 !important;
	font-size: 14px !important;
	border-radius: 2px !important;
}
span.flows_list:not(.unactive):hover {
	color: #5c8df5 !important;
}
span.flows_list.unactive {
	cursor: default;
	pointer-events: none;
}
.edit_name_tf {
	position: relative;
	width: 300px;
	top: 0px;
	left: 0px;
}
.d_name {
	line-height: 18px;
	position: relative;
	display: inline-block;
	padding-right: 30px;
}
.d_name span {
	margin-top: 3px;
	position: relative;
}

.det_btn {
	background: rgba(233, 78, 78, 0.15) !important;
	font-size: 12px !important;
	padding: 1px 10px !important;
}

.test_wrpr {
	position: relative;
	display: inline-block;
	width: 100px;
	height: 26px;
	vertical-align: middle;
	font-size: 14px;
}
.test_wrpr.t_failed {
	width: 270px;
}
/*.test_wrpr.failed{width: 350px}*/
.succ {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	text-align: center;
}
.succ span {
	color: #1bbc9c;
	font-size: 14px;
}
.failed {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	text-align: right;
}
.failed span {
	color: #e94e4e;
}
</style>
